import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import logo from '../images/logo.png';

function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  
  // Get the current disease from the URL path
  const currentDisease = location.pathname.split('/')[1];
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const diseases = [
    'atherosclerosis',
    'lysosomal-storage-disease',
    'pku',
    'diabetes',
    'galactosemia'
  ];

  const lysosmalDiseases = {
    'tay-sachs': 'Tay Sachs',
    'gaucher': 'Gaucher',
    'niemann-pick': 'Niemann Pick'
  };

  // Check if current disease is a lysosomal disease
  const isLysosomalActive = Object.keys(lysosmalDiseases).includes(currentDisease);

  return (
    <nav className="navbar">
      <Link to="/" style={{ textDecoration: 'none' }}>
        <div className="navbar-title">
          <img src={logo} alt="Metabolopedia Logo" className="navbar-logo" />
          <div className="title-text">
            <span className="metabolic">METABOLOPEDIA</span>
            <span className="diseases">A LEARNING HUB FOR METABOLIC DISEASES</span>
          </div>
        </div>
      </Link>
      <div className="nav-links-container">
        {diseases.map(disease => (
          disease === 'lysosomal-storage-disease' ? (
            <div className="dropdown-container" key={disease} ref={dropdownRef}>
              <button 
                className={`nav-link dropdown ${isLysosomalActive ? 'active' : ''}`}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                Lysosomal Storage Disease
              </button>
              {isDropdownOpen && (
                <div className="dropdown-menu">
                  {Object.entries(lysosmalDiseases).map(([key, value]) => (
                    <Link 
                      key={key} 
                      to={`/${key}/pathogenesis`}
                      className={`dropdown-item ${currentDisease === key ? 'active' : ''}`}
                      onClick={() => setIsDropdownOpen(false)}
                    >
                      {value}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <Link 
              key={disease} 
              to={`/${disease}/pathogenesis`}
              className={`nav-link nav-link-${disease} ${currentDisease === disease ? 'active' : ''}`}
            >
              {disease === 'pku' ? 'Phenylketonuria (PKU)' : disease.split('-').map(word => 
                word.charAt(0).toUpperCase() + word.slice(1)
              ).join(' ')}
            </Link>
          )
        ))}
      </div>
    </nav>
  );
}

export default Navbar;